import React from 'react';
import { t } from 'Src/i18n';
import { Spinner } from 'Components/frameworks/spinner/Spinner';
import { Price } from 'Components/frameworks/price/Price';
type Props = {
  isLoading: boolean;
  price?: ProposalPriceDonation | CartPrice;
  className?: string;
  hideUnit?: boolean;
  displayInstalment?: boolean;
  isOnLastPage?: boolean;
};
export const BottomNavbarTotalPrice = ({
  className,
  isLoading,
  price,
  hideUnit,
  displayInstalment,
  isOnLastPage,
}: Props) => {
  return isLoading ? (
    <Spinner size="small" />
  ) : (
    <Price
      bestPrice={price?.total}
      className={className}
      hasAsterisk={false}
      hasInitialPrice
      displayInstalment={displayInstalment}
      hasTaxesAndFeesIncludedLabel
      hasTotalPrice
      initialPrice={price?.totalWithoutDiscount}
      isOnLastPage={isOnLastPage}
      theme="column"
      unit={!hideUnit ? t('booking.priceDetails.packagePrice.totalPrice') : ''}
    />
  );
};
